// Copyright (c) Bentley Systems
export class ActionParameterVm {
  public actionParamId: number | undefined;
  public name: string | undefined;
  /**P = parameter, F = field, C = constant */
  public valueType: string | undefined;
  public value: string | undefined;
}
